var angular = require('angular');
require('ng-dialog');
require('../httpPrefix')
var module =  angular.module("app.directives");

var social = require("../../social");


module.directive("socialLinks", function (ngDialog) {
  return {
    restrict: "E",
    template: require("./index.pug"),
    replace:true,
    require: 'ngModel',
    scope: {
        onChange: "&"
    },
    link: function (scope, el, attrs, ngModel) {
        scope.types = social.Types;
        scope.disabled = attrs.hasOwnProperty('disabled');

        scope.update = function () {
            ngModel.$setViewValue(scope.items);
            scope.onChange && scope.onChange();
        };

        scope.$watch(function () {
            return ngModel.$viewValue;
        }, function (arr) {
            scope.items = arr || [];
        });

        scope.name = function (item) {
            return social.getUsername(item) || item.socialMediaUrl;
        };

        scope.removeItem = function (e, item) {
            e.preventDefault();
            var i = scope.items.indexOf(item);
            scope.items.splice(i, 1);

            //update model
            scope.update();
        };

        scope.isMobile = /Mobi|Android/i.test(navigator.userAgent);
        scope.displaySocialMedia = function (item) {
            var mobileOnly = scope.types[item.socialMediaType].mobileOnly;

            return scope.isMobile || !mobileOnly || !scope.disabled;
        };

      scope.add = function(tab){
        if (scope.disabled) return;
        var dialog = ngDialog.open({
          template: require("./add.pug")(),
          controller: require("./add"),
          plain: true,
          disableAnimation: true,
          className: "ngdialog-theme-default social-link-dialog",
          trapFocus: false,
          resolve: {
            types: function(){ return social.Types }
          }
        });

        dialog.closePromise.then(function(obj) {
          if (obj.value.action == "cancel") return;
          if (obj.value.action == "submit") {
            scope.items.push(obj.value.data);
            scope.update();
          }
        })
      }

    },
  };
});
